import React from 'react';
import { BaasicDropzone } from 'core/components';
import { makePlural } from 'core/utils';
import { defaultTemplate } from 'core/hoc';

const LookupImportTemplate = ({ lookupViewStore, t }) => {
	const itemParameters = lookupViewStore.selectedLookup.parameters;
	let itemName = makePlural(t(itemParameters.itemName));
	var uploadType = '.xls, .xlsx, .csv, text/plain';
	const modalTitle = t('IMPORT');
	return (
		<section className="ReactModal__form">
			<div>
				<h3 className="ReactModal__header">
					{t(modalTitle)} {itemName}
				</h3>
			</div>
			<div className="ReactModal__body">
				<BaasicDropzone acceptFiles={uploadType} onFilesDrop={lookupViewStore.onFilesDrop} />
			</div>
		</section>
	);
};

LookupImportTemplate.propTypes = {};

export default defaultTemplate(LookupImportTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/lookup/pages/LookupImportTemplate.jsx